import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { canAdmin } from '../../utils/permissions';
import { RouteLoadingFallback } from './ProtectedRoute';
/**
 * Gates children to workspace admins. Use inside {@link ProtectedRoute} so
 * authentication and email verification are already satisfied.
 */
export function AdminRoute({ children }) {
    const { user, isLoading } = useAuth();
    if (isLoading) {
        return _jsx(RouteLoadingFallback, {});
    }
    const role = (user?.role ?? 'viewer');
    if (!canAdmin(role)) {
        return _jsx(Navigate, { to: "/", replace: true });
    }
    return _jsx(_Fragment, { children: children });
}
